import Entity from '../entity'

export default class HomeSlider extends Entity<number>{
    imageUrl:string = "";
    linkUrl:string = "";
    alt:string = "";
    displayOrder: number = 1;
}